import React from 'react';
import { useForm, FormContext } from 'react-hook-form';
import TableSearch from 'components/TableSearch';
import SelectController from 'components/select/SelectController';
import Button from '@material-ui/core/Button';
import { zones } from 'data/zones';

import { ToolbarWrapperButton, ToolbarWrapperTop } from 'pages/Products/Toolbar/toolbar.style';

const Toolbar = ({ history, tableRef }) => {
  const paramObj = history?.location?.state || {};
  const defaultValues = {
    zones: null,
    text: ''
  };

  const methods = useForm({
    defaultValues
  });

  const { formState, handleSubmit, reset } = methods;

  const isDirty = formState.dirty || Object.keys(paramObj).find((param) => Boolean(param) === true);

  const onSubmit = (data) => {
    const body = {};

    if (data?.zones) {
      body.zone = data?.zones?.value;
    }
    if (data?.text) {
      body.search = data?.text;
    }

    history.push({
      state: { ...body }
    });

    tableRef.current.onQueryChange();
  };

  const handleClearFilter = () => {
    reset(defaultValues);
    history.push({
      state: {}
    });
    tableRef.current.onQueryChange();
  };

  return (
    <>
      <FormContext {...methods}>
        <ToolbarWrapperButton>
          <TableSearch value={paramObj?.search || ''} onSubmit={onSubmit} mw={230} />
          <ToolbarWrapperTop onSubmit={handleSubmit(onSubmit)}>
            <SelectController
              isClearable
              label="Delivery Zone"
              name="zones"
              options={zones}
              minWidth={150}
            />

            <Button type="submit" variant="contained" color="primary" disabled={!isDirty}>
              Filter
            </Button>
            <Button
              variant="contained"
              type="reset"
              className="reset-toolbar"
              onClick={handleClearFilter}
              disabled={!isDirty}
              style={{ marginLeft: '5px' }}
            >
              Clear
            </Button>
          </ToolbarWrapperTop>
        </ToolbarWrapperButton>
      </FormContext>
    </>
  );
};

export default Toolbar;
